const Form072 = {
    stepName: {
        importantNotes: "背景",
        formType: "表格类型",
        notificationForm: "表单",
        confirmation: "确认页面",
        sign: "签署",
    },
    importantNotesHeader: "背景",
    importantNotesContent:
        "本校会于接获电力公司告知申请结果后，把电力公司发出的批准信或拒绝信提交至教育局学校行政第四组（副本送交学校所属分区高级学校发展主任/高级服务主任），以作记录。本校亦知悉，如安装可再生能源设施涉及校舍任何结构上的改动，本校会按现行规定向教育局提交申请，并须事先获得批准才进行可再生能源设施的安装工程。",
    conditionLabel: {
        termsConditions: "我已阅读条款",
        header1: "标题",
        header2: "条件",
    },
    noteTitle: {
        title1: "摘要",
        title2: "详情",
        title3: "可再生能源设施",
        title4: "参加「上网电价」计划",
        title5: "会计安排",
        title6: "查询",
    },
    noteList: {
        note1: "按教育局通函第168/2019号「学校參加『上网电价』计划」，所有学校向电力公司提交参加「上网电价」计划的申请时，须同时向教育局提交通函所夹附的通知表格，以作记录。在获知申请结果后，学校亦须尽快将电力公司发出的批准函或拒绝信件副本送交教育局，以供存档。详情请参阅以下连结的教育局通函﹕",
        // note1: "本通函旨在通知学校参加「上网电价」计划时须留意的事项。由2019/20学年起本通函取代2018年8月20日的教育局通函第113/2018号。本函应与教育局通告第4/2017号「学校的环保政策及节约能源措施」一并阅读，以配合学校的环保政策及环保教育。",
        // note1a: "学校参加「上网电价」计划的安排不适用于官立学校。",
        note1a: "https://applications.edb.gov.hk/circular/upload/EDBCM/EDBCM19168S.pdf",
        note2: "有关提交电子表格的查询，请与支持热线联络。",
        // note2: "2. 香港政府与两间电力公司（即中华电力有限公司及香港电灯有限公司）于2017年4月签订新的《管制计划协议》（《协议》）。考虑了市民的意见及为应对气候变化，新《协议》引入多项措施，鼓励电力公司自行发展可再生能源，并同时促进可再生能源的发展。当中，引入「上网电价」计划是新《协议》中推广可再生能源的一项重要措施。「上网电价」计划由两间电力公司推行，鼓励私营机构及社区发展可再生能源，然后以高于一般电费水平的价格，把所生产的电力售予电力公司。",
        note3: "3. 为配合政府的环保政策，环境局与教育局鼓励学校在不妨碍学生活动及安全的情况下在校舍内安装可再生能源系统。中、小学及幼稚园",
        note3a: "亦可因应学校的情况，参加「上网电价」计划。我们希望学校在参与计划时，能善用已安装的可再生能源系统，推动校内的环保教育。学校在安装可再生能源设施及参加「上网电价」计划时，须留意以下各项：",
        note4N: "(i)",
        note4: "所有学校可以申请适用的政府资助（如环境及自然保育基金和「采电学社：学校及非政府福利机构太阳能支援计划」",
        note4a: "）或运用捐赠及赞助等，购买、租用、安装、更换或维修保养可再生能源设施，以及支付相关设施的其他经常费用（如有）。此外，资助学校及按位津贴学校可以使用普通经费帐内的经费来支付有关费用。不过，收取学费的学校",
        note4b: "不可直接运用学费收入作相关用途；而接受政府经常性资助的学校",
        note4c: "，亦不可透过任何借贷安排（包括但不限于分期付款）或教育局的资助（包括紧急修葺工程及年度大规模修葺工程）来购买、租用、安装、更换或维修保养",
        note4d: "可再生能源设施，以及支付相关设施的其他经常费用（如有）",
        note5N: "(ii)",
        note5: "所有学校安装可再生能源设施，如涉及任何结构上的改动，应按现行规定向教育局提交申请，并须事先获得批准",
        note5a: "。",
        note6N: "(iii)",
        note6: "在购买、租用、安装、更换或维修保养可再生能源设施时，所有学校应参照本局现行的通告和指引",
        note6a: "，在公开和公平的原则下，定期进行具竞争性的招标／报价程序甄选供应商／承办商。所有学校不应索取或接受供应商／承办商的捐赠或任何形式的利益。",
        note7N: "(iv)",
        note7: "所有学校应善用已安装的可再生能源系统，透过学校的教学活动",
        note7a: "或课余活动，增进学生的环保知识。",
        note8N: "(v)",
        note8: "学校参加「上网电价」计划属商业活动，资助学校、按位津贴学校、直资学校及英基学校须遵照本局通告第10/2016号「学校的商业活动」的相关规定",
        note8a: "，未设有法团校董会的学校必须事先得到教育局常任秘书长书面准许。请注意，一般商业活动的利润上限并不适用于「上网电价」计划。接受政府经常性资助的学校",
        note8b: "及属于非牟利的私立学校和幼稚园须将有关收入应用于直接让学生受惠的用途，例如举办促进环境保护的教育活动及购买、租用或维修保养可再生能源设施。",
        note9N: "(vi)",
        note9: "所有学校参加「上网电价」计划均须由校董会／法团校董会批准。",
        note10N: "(vii)",
        note10: "所有学校不可租借校舍，以让第三方参加「上网电价」计划。接受政府经常性资助的学校",
        note10a:
            "及属于非牟利的私立学校和幼稚园不可透过向第三方分派收入的方式与他人合作，以参加「上网电价」计划。",
        note11N: "(viii)",
        note11: "所有学校须留意接驳电网安排，以及与安装可再生能源发电系统有关的法例。",
        note12N: "(ix)",
        note12: "所有学校向电力公司提交参加「上网电价」计划的申请时，须同时向教育局提交本通函所夹附的通知表格，以作记录。在获知申请结果后，学校亦须尽快把电力公司发出的批准函或拒绝信件传真至本局学校行政第四组（副本送交学校所属高级学校发展主任/高级服务主任），以供存档。",
        note13N: "(x)",
        note13: "所有学校须为「上网电价」的收入与相关支出备存一个独立账目。学校须保存收支记录及相关的收据／发票，以供本局有需要时查核。",
        note14N: "(xi)",
        note14: "各类学校须按教育局要求，将「上网电价」独立账目内的收入与相关支出，反映于经审核账目内",
        note14a:
            "。资助学校及按位津贴学校应将收支填报在普通经费帐，以反映「上网电价」项目的收支；而直资学校和参加幼稚园教育计划的幼稚园",
        note14b:
            "，以及须按本局既定格式制备经审核账目的私立学校及英基学校协会辖下与教育局签订服务合约的学校，则应将收支填报在经审核账目内的报表／附注中，以反映「上网电价」项目的收支；至于不须按本局既定格式制备经审核账目的私立学校及英基学校协会辖下的其余学校，应按既定的会计准则将有关收支反映于经审核账目／财务报告内。",
        note15N: "(xii)",
        note15: "各类学校应以「上网电价」的相关收入或参照上文第3(i) 段，使用合适的资金，支付所需的开支（例如接驳电网的费用及维修保养可再生能源设施的支出）或任何亏损。",
        note16N: "(xiii)",
        note16: "资助学校及按位津贴学校应将「上网电价」的收入盈余（如有的话）记入普通经费帐，而收取学费的学校",
        note16a:
            "则可将盈余于非政府经费帐／学校经费帐累积，以支付可再生能源设施日后的维修保养开支和用于直接让学生受惠的用途。请注意，所有学校应就参加「上网电价」计划制备现金流的预算，并保留足够的余款，以应付未来可能出现的开支或任何亏损。在购买或租用可再生能源设施时，学校应审慎评估「上网电价」的收入／盈余是否足够支付任何服务合约的所需开支，并小心谨慎地订立相关服务合约的条款（如合约总金额、合约期及付款模式等）。接受政府经常性资助的学校",
        note16b:
            "及属于非牟利的私立学校和幼稚园不得以任何形式把「上网电价」计划所产生的收入分派、捐赠或贷款给第三者或调往其他帐项。",
        note17N: "(xiv)",
        note17: "收取学费的学校",
        note17a:
            "不可藉参加「上网电价」为理由而增加学费，相关开支亦不会纳入学费调整申请的评估之内。",
        note18: "4. 本局透过通告第4/2017号「学校的环保政策及节约能源措施」，促请所有学校制订并推行校本环保政策，有关环保政策须获校董会／法团校董会批准，并期望学校能定期在校董会／法团校董会会议上汇报，以达到不断检视和持续发展的目的。如学校参加「上网电价」计划，可配合校本环保政策，推动可再生能源发展。我们促请学校积极向社区及持份者展示推行校本环保政策的成果，例如于学校网页分享学校参加「上网电价」计划、举办相关的环境保护教育活动详情及成效，进一步推广环保教育。",
        note19: "5. 就参加「上网电价」计划的查询，请与下列有关机构／人员联络：",
        note20: "教育局局长",
        note21: "刘玉莲代行",
        note22: "二零一九年九月二日",
        tableTile: "查询内容",
        tableTile2: "查询途径",
        tableLeft: "电力公司的「上网电价」计划详情",
        tableLeft2: "安装可再生能源设施的技术问题",
        tableLeft3: "学校参加「上网电价」的安排",
        tableLeft4: "其他查询（例如涉及任何结构改动的工程）",
        tableRight: "中华电力有限公司",
        tableRight2: "电话：2678 0322",
        tableRight3: "电邮地址：",
        tableRight4: "csd@clp.com.hk",
        tableRight5: "香港电灯有限公司",
        tableRight6: "电话：2510 2701",
        tableRight7: "RE@hkelectric.com",
        tableRight8: "机电工程署",
        tableRight9: "「香港可再生能源网」的「上网电价」专页：",
        tableRight10: "http://re.emsd.gov.hk/eindex.html",
        tableRight11: "热线电话：6395 2930",
        tableRight12: "eepublic@emsd.gov.hk",
        tableRight13: "教育局学校行政第四组",
        tableRight14: "电话：3509 7459",
        tableRight15:
            "所属的教育局分区高级学校发展主任或幼稚园及幼儿中心联合办事处高级服务主任",
    },
    noteTips: {
        tips1: "包括幼稚园、幼稚园暨幼儿中心及设有幼稚园班级的学校。",
        tips2: "学校可透过有关连结参阅两项计划的详请（包括申请资格、计划范畴等）：环境自然保育基金（https://eeca.ecc.org.hk/uploadfiles/tc/EECA_Guide%20to%20Application_TC(Mar2019).pdf）采电学社（https://re.emsd.gov.hk/tc_chi/gen/4S/4S.html）",
        tips3: "包括直资学校、英基学校、私立学校和幼稚园。",
        tips4: "包括资助学校、按位津贴学校、直资学校、英基学校，以及参加幼稚园教育计划的幼稚园和曾参加学前教育学券计划或幼稚园教育计划，但仍有部份学生获有关计划资助的幼稚园。",
        tips5: "就维修保养可再生能源设施，设有法团校董会的资助学校，亦可使用扩大的营办开支整笔津贴的余款，来补贴不超过(i)政府资助计划的经常开支的50%；以及(ii)透过私人捐赠或其他筹款计划而得到的家具、设备和其他设施或教育服务的经常开支的25 %。",
        tips6: "《教育规例》(第279A章)第10(a)条订明，除经常任秘书长以书面同意外，不得对校舍作任何结构上的改动。",
        tips7: "资助学校、按位津贴学校及直资学校应参照本局通告第4/2013号「资助学校采购程序」；其他学校须合符教育局通告第14/2003号「学校及其教职员收受利益和捐赠事宜」内相关要求。就有关合约期的安排，所有学校应参照本局通告第10/2016号「学校的商业活动」附录4「在公帑资助学校内以高于标准的设施经营业务／商业活动的基本指导原则」的第(i)项，以及政府效率促进办公室的「合约管理用者指引」（https://www.effo.gov.hk/tc/reference/publications/cm2007_tc.pdf）第6.3段办理。",
        tips8: "如学校有关的可再生能源设施设置于天台，而学校有意在天台进行教学活动，应参阅《教育规例》第16至20条就天台操场的规定。",
        tips9: "私立学校应遵从本局通告第17/2003号「在私立学校售卖教育用品及提供收费服务的指引」；而幼稚园须同时遵从本局通告第16/2013号「幼稚园收取费用、售卖教育用品及提供收费服务」的相关规定。",
        tips10: "资助学校、按位津贴学校、直资学校和参加幼稚园教育计划的幼稚园，以及须按本局既定格式制备经审核账目的私立学校及英基学校协会辖下与教育局签订服务合约的学校，须将「上网电价」独立账目内的收入与相关支出，反映在2018/19年度及往后的经审核账目内。本局会另行通知各类学校有关拟备经审核账目的详情。",
        tips11: "包括曾参加学前教育学券计划或幼稚园教育计划，但仍有部份学生获有关计划资助的幼稚园。",
    },
    titleOption: {
        Mr: "先生",
        Mrs: "太太",
        Miss: "小姐",
        Ms: "女士",
        Others: "其他",
    },
    schoolHeadOption: {
        supervisor: "校监",
        head: "校长",
    },
    formLabel: {
        companies: {
            CLP: "中华电力有限公司",
            electricCompany: "香港电灯有限公司",
        },
        or: "或",
        schoolName: "学校名称",
        date: "日期",
        header: "学校参加「上网电价」计划通知表格",
        headerY: "（",
        headerN: "（不",
        headerLastText: "连同电力公司的批准信或拒绝信）",
        formType: "选择需要提交的资料",
        notificationForm: "填写通知表格／提交电力公司信件",
        // attachment: "附件",
        attachment: "上传电力公司的批准信或拒绝信",
        attachmentRemarkHaveLetter:
            "[注：如贵校并未曾收到相关批准或拒绝信件，请在底部点击「返回」，以及在「第二步」选择「提交通知表格（不连同电力公司的批准信或拒绝信）」。]",
        attachmentRemarkUploadLetter:
            "[注：如贵校并未曾向教育局提交『学校参加「上网电价」计划通知表格』，请在底部点击「返回」，以及在「第二步」选择「提交通知表格（连同电力公司的批准信或拒绝信）」。]",
        schoolHead: "请选择校监／校长",
        schoolHeadTitle: "（称谓：",
        afterSchoolHeadTitle: "）",
        schoolHeadName: "姓名",
        schoolHeadSign: "签署：",
        contactNameTitle: "（称谓：",
        contactName: "联络人姓名",
        labelbeforeDistrict: "本通知应送抄：",
        labelAfterDistrict: "（所属分区）高级学校发展主任/高级服务主任，即",
        district: "所属分区",
        completedBySchool: "此栏由学校填写",
        otherContactNameTitle: "称谓",
        ssdoLabel: "高级学校发展主任",
    },
    formContent: {
        componyRadioBeforeText: "本校决定申请参加",
        componyRadioAfterText: "",
        dateBeforeText: "推出的「上网电价」计划，并已于",
        dateAfterText: "递交申请。",
        decideCompany1: "电力公司名称",
        submitDate: "申请表提交日期为",
        submitTypeOption: {
            noLetter: "提交通知表格（不连同电力公司的批准信或拒绝信）",
            uploadLetter: "只上传电力公司的批准或拒绝信",
            haveLetter: "提交通知表格（连同电力公司的批准信或拒绝信）",
        },

        districtOptions: {
            JOINT_OFFICE_FOR_KINDERGARTENS_AND_CHILD_CARE_CENTRES:
                "幼稚园及幼儿中心联合办事处",
            North: "北区",
            KWwai_Tsing: "葵青区",
            Sai_Kung: "西贡区",
            Eastern: "东区",
            Tuen_Mun: "屯门区",
            Kowloon_City: "九龙城区",
            Kwun_Tong: "观塘区",
            Southern: "南区",
            Yau_Tsim_Mong: "油尖旺区",
            Tsuen_Wan: "荃湾区",
            Sha_Tin: "沙田区",
            Sham_Shui_Po: "深水埗区",
            Tai_Po: "大埔区",
            Wan_Chai: "湾仔区",
            Islands: "离岛区",
            Central_And_Western: "中西区",
            Yuen_Long: "元朗区",
            Wong_Tai_Sin: "黄大仙区",
        },
        attachment: {
            title: "备注：",
            content: "每个文件的最大大小为1MB",
            content2: "可接受的文件类型：pdf, jpg, png, doc, docx  ",
            content3: "最大文件数：5",
        },
    },
};
export default Form072;
